/* eslint-disable react/no-danger */
import * as React from 'react';

import * as styles from './OneTwoTripBanner.css';

import imgGlobe from './assets/globe.svg';
import { UIHeading2, UIHeading5, UIText2 } from '@cian/ui-kit';

export type TOneTwoTripBannerProps = {
  onClick(): void;
  url: string;
};

export const OneTwoTripBanner: React.VFC<TOneTwoTripBannerProps> = ({ onClick, url }) => {
  const clickHandler = () => {
    onClick();

    window.open(url, '_blank');
  };

  return (
    <div className={styles['container']} onClick={clickHandler} data-testid="OneTwoTripBanner">
      <span className={styles['flag']}>Новинка</span>
      <div className={styles['info']}>
        <img src={imgGlobe} width="40" height="40" />
        <div className={styles['text']}>
          <UIHeading2 color="white_100">Ищите жильё по всему миру</UIHeading2>
          <UIHeading5 color="white_100">Отели, хостелы, апартаменты и дома</UIHeading5>
        </div>
      </div>
      <span className={styles['label']}>
        <UIText2 color="white_100" fontWeight="500" display="inline-block">
          Искать на OneTwoTrip
        </UIText2>
      </span>
    </div>
  );
};
